import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
export var DIVIDER_DISPLAY_NAME = '-';
export function getComposeActionDisplayName(key) {
    switch (key) {
        case 'AddAttachment':
            return strings.attachTooltip;
        case 'AddInlineImage':
            return strings.insertPicturesInlineTooltip;
        case 'AddEmoji':
            return strings.emojiTooltip;
        case 'ToggleRibbon':
            return strings.formattingOptionsTooltip;
        case 'SaveDraft':
            return strings.saveDraft;
        case 'InsertSignature':
            return strings.insertSignature;
        case 'ShowFrom':
            return strings.showFrom;
        case 'SetImportance':
            return strings.setImportance;
        case 'SwitchBodyType':
            return strings.switchToPlainTextMenuItem;
        case 'ProtectMessage':
            return strings.composeProtectButton;
        case 'AccChecker':
            return strings.accCheckerMenuItemText;
        default:
            return '';
    }
}
export function getReadActionDisplayName(key) {
    switch (key) {
        case 'LikeUnlike':
            return strings.itemHeaderLike;
        case 'Reply':
            return strings.itemHeaderReply;
        case 'ReplyAll':
            return strings.itemHeaderReplyAll;
        case 'Forward':
            return strings.itemHeaderForward;
        case 'Popout':
            return strings.popoutsOpenInNewWindow;
        case 'Delete':
            return strings.itemHeaderDelete;
        case 'MarkReadUnread':
            return strings.markAsUnread;
        case 'FlagUnflag':
            return strings.itemHeaderFlag;
        case 'MarkJunkNotJunk':
            return strings.itemHeaderMarkAsJunk;
        case 'MarkAsPhishing':
            return strings.itemHeaderMarkAsPhishing;
        case 'Block':
            return format(strings.itemHeaderBlock, '');
        case 'CreateRule':
            return strings.createRule;
        case 'Print':
            return strings.itemHeaderPrint;
        case 'Translate':
            return strings.itemHeaderTranslate;
        case 'ShowInImmersiveReader':
            return strings.showInImmersiveReader;
        case 'ViewMessageSource':
            return strings.itemHeaderViewMessageSource;
        case 'ToggleDarkMode':
            return strings.itemHeaderLightsOn;
        default:
            return '';
    }
}
//# sourceMappingURL=getDisplayNameFromKey.js.map